import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from '../index.module.scss';
import isEmpty from 'lodash/isEmpty';
import Section from 'components/Section';
import DetailGeneralInfo from 'components/DetailGeneralInfo';
import {
  getSecurityCompanyBillingInfo,
  getSecurityCompanyDetail,
} from 'reducers/securityCompany';
import AddPayment from './addPayment';
import { transform } from 'utils/DataTransform/SecurityCompanies/securityCompanyAccountInfo';

import Loader from 'components/Loader';
import {
  NO_CREDITCARD_STRPE_MESSAGE,
  NO_CREDITCARD_TITLE,
} from 'utils/constants/securityCompany';
import { useTranslation } from 'react-i18next';

const getBillingData = data => {
  if (!isEmpty(data)) {
    return <DetailGeneralInfo display="block" data={data} />;
  } else {
    return <Loader outline />;
  }
};

const BillingInfo = ({ securityCompanyBillingInfo, securityCompanyDetail }) => {
  const { t } = useTranslation();
  const [showPaymentPanel, setShowPaymentPanel] = useState(false);
  const transformedData = transform(
    securityCompanyDetail,
    securityCompanyBillingInfo,
  );

  const onPaymentMethodEdit = () => {
    setShowPaymentPanel(true);
  };
  const closePaymentPanel = () => {
    setShowPaymentPanel(false);
  };

  const haveCard = isEmpty(securityCompanyBillingInfo)
    ? false
    : securityCompanyBillingInfo.paymentMethod.last4;

  const last4Num = securityCompanyBillingInfo?.paymentMethod?.last4 !== '';

  useEffect(() => {
    if (!isEmpty(securityCompanyBillingInfo)) {
      setShowPaymentPanel(!securityCompanyBillingInfo.paymentMethod.last4);
    }
  }, [securityCompanyBillingInfo]);

  return (
    <>
      <div className={styles.infoPanel}>
        {haveCard ? (
          <>
            <Section
              text="Billing"
              className={styles.billingSection}
              expandable={false}
              editable={true}
              onEdit={onPaymentMethodEdit}
            >
              {getBillingData(transformedData.currentPaymentMethod)}
            </Section>
          </>
        ) : (
          <Section
            text="Add Payment"
            className={styles.planSection}
            expandable={false}
            editable={true}
            onEdit={onPaymentMethodEdit}
          >
            <div className={styles.addPaymentMessage}>
              {t(NO_CREDITCARD_STRPE_MESSAGE)}
            </div>
          </Section>
        )}
      </div>
      {showPaymentPanel && (
        <AddPayment
          last4Num={last4Num}
          close={closePaymentPanel}
          {...(!haveCard && {
            header: t(NO_CREDITCARD_TITLE),
            message: t(NO_CREDITCARD_STRPE_MESSAGE),
          })}
        />
      )}
    </>
  );
};
BillingInfo.propTypes = {
  securityCompanyProfile: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  securityCompanyBillingInfo: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool,
  ]),
  securityCompanyBillingInfoRaw: PropTypes.object,
  securityCompanyImage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  showEditCompany: PropTypes.bool,
  toggleModal: PropTypes.func,
  fetchBillingInfo: PropTypes.func,
  companyId: PropTypes.string,
  fetchCompanyDetails: PropTypes.func,
  securityCompanyDetail: PropTypes.object,
};

const mapStateToProps = state => ({
  securityCompanyDetail: getSecurityCompanyDetail(state),
  securityCompanyBillingInfo: getSecurityCompanyBillingInfo(state),
});

export default connect(mapStateToProps, null)(BillingInfo);
